
import { Element } from "./element";
import { heckbert, LIM10 } from "../../../lib/nice_num";
import { rem_to_px } from "../px";

/**
 * Renders a y-axis into a chart.
 */

class YAxis extends Element {


  calcMinMax = data => {
    let min = data[0];
    let max = data[0];
    data.forEach(value => {
      min = Math.min(min, value);
      max = Math.max(max, value);
    });
    return { min, max }
  };

  calcMinMaxAll = (tickData) => {
    const allMinMax = tickData.map(line => this.calcMinMax(line.data));
    this.dataMin = this.calcMinMax(allMinMax.map(item => item.min)).min;
    this.dataMax = this.calcMinMax(allMinMax.map(item => item.max)).max;
    // If dataMin is less then 0.01 of dataMax, then set dataMin to be 0.01 less than dataMax.
    // For heckbert, this creates an infinite loop
    if (Math.abs(this.dataMin - this.dataMax) < 0.01) {
      this.dataMin = 0;
    }
  };

  valueToY = value => {
    return (value - this.dataMin) * this.dPdV + this.graphBottom;
  };

  renderTick = (ctx, label, value) => {
    const tickLength = rem_to_px(0.5);
    const y = this.valueToY(value);
    ctx.beginPath();
    ctx.moveTo(this.right - tickLength, y);
    ctx.lineTo(this.right, y);
    ctx.stroke();

    ctx.textAlign = "left";
    ctx.fillStyle = "#000";
    ctx.fillText(label, this.left, y + rem_to_px(0.2));
  };

  renderHorizontalLine = (ctx, fromX, toX, y) => {
    ctx.strokeStyle = "#CCC";
    ctx.beginPath();
    ctx.moveTo(fromX, y);
    ctx.lineTo(toX, y);
    ctx.stroke();
  };

  render = (canvas, tickData) => {
    this.updatePos();

    // left line
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 1;

    ctx.beginPath();
    ctx.moveTo(this.right, this.top);
    ctx.lineTo(this.right, this.bottom);
    ctx.stroke();

    this.calcMinMaxAll(tickData);
    const sc = 0.9;
    const centerY = (this.top + this.bottom) / 2.;
    this.dPdV = (this.top - this.bottom) / ( this.dataMax - this.dataMin) * sc;
    this.graphBottom = (this.bottom - centerY) * sc + centerY;

    // Render labels
    let labels = heckbert(this.dataMin, this.dataMax, 10, LIM10, true);
    labels.forEach(({label, value}) => {
      const y = this.valueToY(value);
      if (y <= this.bottom) {
        this.renderTick(ctx, label, value);
        this.renderHorizontalLine(ctx, this.right, canvas.width, y);
      }
    })

  }

}

export { YAxis };
